module.exports = __webpack_public_path__ + "static/media/banner_BigSmall-half.f4754b7b.png";